import React, { createContext, useReducer, useEffect } from 'react'
import { authReducer } from '../reducers/authReducer'
import jwt from 'jsonwebtoken'

export const AuthContext = createContext()

const AuthContextProvider = (props) => {
  const getLocalData = (data) => {
    let returnData = {}
    jwt.verify(data, process.env.REACT_APP_AUTH_HASH, function (err, decoded) {
      if (err) {
        returnData = { user: null, userToken: null, isLoading: false }
      } else {
        returnData = { user: decoded.user, userToken: data, isLoading: false }
      }
    });
    return returnData
  }
  const [auth, dispatch] = useReducer(authReducer, { user: null, userToken: null, isLoading: false }, () => {
    const localData = localStorage.getItem('mpt-Token');
    if (localData) {
      return getLocalData(localData)
    } else {
      localStorage.clear()
      return { user: null, userToken: null, isLoading: false }
    }
  })

  useEffect(() => {
    if (auth.userToken)
      localStorage.setItem('mpt-Token', auth.userToken)
    else 
      localStorage.clear()
  }, [auth])
  return (
    <AuthContext.Provider value={{ auth, dispatch }}>
      {props.children}
    </AuthContext.Provider>
  )
}
export default AuthContextProvider